// 是否开启测试模式
const isTest = false

const wxProdConfig = {
  appId:'wx77ddd3fbc162262c',
  noncestr : 'Wm3WZqwkeqklejzccnW',
  timestamp : 1414587457
}

const wxTestConfig = {
  appId:'wx2f952f95a9fb04c7',
  noncestr : 'Wm3WZqwkeqklejzccnW',
  timestamp : 1414587457,
}

exports.backendConfig = {
  serverHost: isTest ? 'http://192.168.0.2:8080' : 'https://backend.smhszdh.com'
}

exports.homepageDir = isTest ? 'http://js-agent.newrelic.com:3000' : 'https://laotu.smhszdh.com'

if (isTest) {
  exports.wxConfig = wxTestConfig
} else {
  exports.wxConfig = wxProdConfig
}

exports.isTest = isTest


// WEBPACK FOOTER //
// ./constant/wxConfig.js